import { TextField } from "@mui/material";
import {
  Control,
  Controller,
  FieldPath,
  FieldValues,
  RegisterOptions
} from "react-hook-form";
import { useTranslation } from "react-i18next";

export const ReactHookFormTextField = <
  InputTypeFieldValues extends FieldValues = FieldValues,
  InputName extends FieldPath<InputTypeFieldValues> = FieldPath<InputTypeFieldValues>
>({
  control,
  fieldName,
  rules,
  label,
  required,
  disabled
}: {
  control: Control<InputTypeFieldValues>;
  fieldName: InputName;
  rules?: Omit<
    RegisterOptions<InputTypeFieldValues, InputName>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  label: string;
  required?: boolean;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      name={fieldName}
      rules={rules}
      render={({ field: { onChange, onBlur, value } }) => (
        <TextField
          onChange={onChange}
          onBlur={onBlur}
          label={t(label)}
          value={value}
          sx={{ width: "100%" }}
          required={required}
          disabled={disabled}
        />
      )}
    />
  );
};
